<template>
    <ContentOrLoading>
        <SvgComponent :zonas="zonas" :zona_id="zona_id" :place="place" :sesion_id="sesion_id" @clickZona="irAZona" />
    </ContentOrLoading>
</template>

<script>
    import SvgComponent from '@/components/svg/SvgComponent';

    export default {
        props: ['zonas', 'zona_id', 'can_click', 'popup_enabled', 'occupied', 'place', 'sesion_id'],
        data() {
            return {
                loading: true
            }
        },
        methods: {
            irAZona(zona) {
                this.$emit('clickZona', 2, zona);
            }
        },
        components: {
            SvgComponent
        }
    }
</script>
